import { Link } from 'react-router-dom';
import type { hotGossipItems as HotItemType } from '@/mocks/home';

interface CategoryGridProps { items: typeof HotItemType; categoryName: string; }

export default function CategoryGrid({ items, categoryName }: CategoryGridProps) {
  if (items.length === 0) {
    return (
      <section className="w-full py-16 md:py-24">
        <div className="w-full px-6 md:px-10 max-w-6xl mx-auto text-center">
          <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center rounded-full bg-background-100">
            <i className="ri-inbox-line text-3xl text-foreground-400"></i>
          </div>
          <h2 className="text-2xl font-heading font-bold text-foreground-950 mb-3">暂无内容</h2>
          <p className="text-sm text-foreground-500 mb-6">{categoryName}分类下的爆料内容正在整理中，请稍后再来查看</p>
          <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-950 text-background-50 text-sm font-medium rounded-full hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap font-label"><i className="ri-arrow-left-line"></i>返回首页</Link>
        </div>
      </section>
    );
  }
  return (
    <section className="w-full py-16 md:py-24">
      <div className="w-full px-6 md:px-10 max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-xs font-medium text-secondary-500 uppercase tracking-widest font-label mb-3">{categoryName}</p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950">最新{categoryName}火速围观</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {items.map((item) => (
            <Link key={item.id} to={`/article/${item.slug}`} className="group block bg-background-100 rounded-xl overflow-hidden hover:bg-background-200/70 transition-colors duration-300">
              <div className="relative">
                {item.isHot && <span className="absolute top-3 left-3 z-10 px-2.5 py-1 text-[10px] font-semibold bg-primary-500 text-background-50 rounded-md font-label uppercase tracking-wider">热门</span>}
                <div className="w-full overflow-hidden" style={{ aspectRatio: '3/4' as string }}>
                  <img src={item.image} alt={`${item.name} - ${item.title}`} title={`51黑料吃瓜网 - ${item.name}${item.title}`} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
                </div>
              </div>
              <div className="p-4">
                <span className="inline-block px-2 py-0.5 text-[10px] font-medium bg-secondary-100 text-secondary-700 rounded-full mb-2 font-label">{item.category}</span>
                <h3 className="text-sm font-semibold text-foreground-950 mb-1 line-clamp-2 leading-snug">{item.name}：{item.title}</h3>
                <p className="text-xs text-foreground-500 mb-3 line-clamp-2 leading-relaxed">{item.summary}</p>
                <div className="flex items-center gap-1 text-xs text-foreground-400"><i className="ri-fire-line text-accent-500"></i><span>{item.heat} 热度</span></div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}